/** USDC — collateral, fees, notional (6 decimal places). */
export const USDC_DECIMALS = 6;

/** Prices, OI token amounts, funding / rollover accumulators (18 decimal places). */
export const TOKEN_DECIMALS = 18;

/** Leverage stored on-chain as leverage × 100 (2 decimal places). */
export const LEVERAGE_DECIMALS = 2;

export const PRECISION_6  = 1_000_000n;
export const PRECISION_18 = 1_000_000_000_000_000_000n;
